/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import Layout from './layout';

import { entitiesMetaData } from '../../redux/modules/entities/metaData';
import { getHelpLink } from '../EntityTable/selectors';

export const mapStateToProps = (state) => ({
  pageTitle: entitiesMetaData['wfm'] ? entitiesMetaData['wfm'].pageTitle : '',
  pageHelpLink: getHelpLink(state),
});

export default connect(mapStateToProps)(Layout);
